import "../../index.scss";
import { OBJECT_ENTRY_URL_SEPARATOR } from "../../utils/constants";
import ClayLayout from "@clayui/layout";
import { useEffect, useState } from "react";
import { getCertificationsList } from "../../services/certification";
import SectionCard from "../Common/SectionCard";

const CertificationsList = () => {
  const [certifications, setCertifications] = useState(null);

  useEffect(() => {
    const fetchCertifications = async () => {
      const response = await getCertificationsList();

      const certifications = response.slice(0, 3);

      setCertifications(certifications);
    };

    fetchCertifications();
  }, []);

  return (
    <ClayLayout.ContainerFluid view>
      <ClayLayout.Row justify="start">
        {certifications && certifications.length > 0 && (
          <>
            {certifications.map((certification, index) => {
              return (
                <SectionCard
                description={
                  !certification.description ? "" : certification.description
                }
                expertise=""
                index={index}
                key={certification.id}
                link={`/${OBJECT_ENTRY_URL_SEPARATOR.CERTIFICATION}/${certification.id}`}
                personas={certification.persona}
                title={!certification.title ? "" : certification.title}
              />
              );
            })}
          </>
        )}
      </ClayLayout.Row>
    </ClayLayout.ContainerFluid>
  );
};

export default CertificationsList;
